import { render, staticRenderFns } from "./MediaSettings.vue?vue&type=template&id=7c03922a&scoped=true"
import script from "./MediaSettings.vue?vue&type=script&lang=js"
export * from "./MediaSettings.vue?vue&type=script&lang=js"
import style0 from "./MediaSettings.vue?vue&type=style&index=0&id=7c03922a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c03922a",
  null
  
)

export default component.exports